import React from 'react';
import Loading from "../components/Loading";
import TableOrdersModal from '../components/modals/TableOrdersModal';
import TableCard from '../components/cards/TableCard';
import { useTablesContext } from '../context/TablesContext';
import { useRequestsContext } from '../context/RequestsContext';
import { decorateTablesWithRequestAttention } from '../utils/tableDisplayState';
import '../styles/Pages.css';

const TablesPage = () => {
  const {
    allTables,
    tables,
    loading,
    floors,
    currentFloor,
    setCurrentFloor,
    selectedTable,
    orders,
    showModal,
    handleTableClick,
    handleCloseModal,
  } = useTablesContext();
  const { requests, loading: requestsLoading } = useRequestsContext();

  if (loading || requestsLoading) {
    return <Loading />;
  }

  const displayTables = decorateTablesWithRequestAttention(tables, requests);

  return (
    <div className="venue-page">
      <section className="venue-surface-card venue-surface-card--padded">
        <div className="venue-section-header">
          <h2 className="venue-section-title">Kat Seçimi</h2>
        </div>
        <div className="venue-floor-switcher">
          {floors.map((floor) => (
            <button
              key={floor.id}
              type="button"
              className={`venue-floor-switcher__button ${currentFloor?.id === floor.id ? 'active' : ''}`}
              onClick={() => setCurrentFloor(floor)}
            >
              {floor.name}
            </button>
          ))}
        </div>
      </section>

      <section className="venue-surface-card venue-surface-card--padded">
        <div className="venue-section-header">
          <h2 className="venue-section-title">Masa Durumu</h2>
        </div>
        {tables.length === 0 ? (
          <div className="venue-empty-state">
            <p className="venue-empty-state__title">Bu katta masa yok</p>
            <p className="venue-empty-state__text">Yeni bir kat veya masa tanımı bekleniyor.</p>
          </div>
        ) : (
          <div className="venue-tables-grid">
            {displayTables.map((table) => (
              <TableCard
                key={table.id}
                table={table}
                handleTableClick={handleTableClick}
              />
            ))}
          </div>
        )}
      </section>

      <TableOrdersModal
        show={showModal}
        handleClose={handleCloseModal}
        selectedTable={selectedTable}
        tables={allTables}
        orders={orders}
        floors={floors}
      />
    </div>
  );
};

export default TablesPage;
